<script setup lang="ts">
import VeeAttachments from '@/components/forms/Attachments/VeeAttachments.vue';
import VeeAvailability from '@/components/forms/Availability/VeeAvailability.vue';
import FormSection from '@/components/forms/FormSection/FormSection.vue';
import VeeTextarea from '@/components/forms/Textarea/VeeTextarea.vue';
import VeeTextField from '@/components/forms/TextField/VeeTextField.vue';
import Protocols from '@/components/Protocols/Protocols.vue';
import EntityChangeBlock from '@/components/EntityHistory/EntityChangeBlock.vue';
import JobConfigurationFormSchedule from './JobConfigurationFormSchedule.vue';
import JobConfigurationFormAssignment from './JobConfigurationFormAssignment.vue';
import JobConfigurationFormReview from './JobConfigurationFormReview.vue';

import { useFormMode } from '@/components/forms/useFormMode.ts';
import { useFormValues } from 'vee-validate';
import { JobConfigurationDto } from '@/api/generator';

const mode = useFormMode();

const values = useFormValues<JobConfigurationDto>();
</script>

<template>
  <FormSection>
    <v-row>
      <v-col cols="10">
        <v-row>
          <v-col cols="3">
            <VeeTextField :label="$t('Name')" name="name" :placeholder="$t('Required')" />
          </v-col>
          <v-col cols="7">
            <Protocols name="protocols" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10">
            <VeeTextarea :label="$t('Description')" name="description" class="gutterTop" />
            <VeeAttachments class="mt-1" name="attachments" :mode="mode" />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="2">
        <VeeAvailability
          name="isAvailable"
          :isReferencedBy="values.isReferencedBy ?? undefined"
          :hideReferences="true"
          :impactMessage="
            $t('DisableJobConfigurationInfoMsg', {
              entityName: $t('JobConfiguration_one'),
            })
          "
        />
        <EntityChangeBlock v-if="mode === 'details'" :entity="values" />
      </v-col>
    </v-row>

    <v-divider class="mt-5 mb-5" />

    <v-row class="mb-4">
      <v-col>
        <div class="text-h5">
          {{ $t('JobConfigurationExecutionAssignmentHeader') }}
        </div>
        <JobConfigurationFormAssignment class="mt-4" />
      </v-col>
      <v-col>
        <div class="text-h5">
          {{ $t('JobConfigurationReviewAssignmentHeader') }}
        </div>
        <JobConfigurationFormReview class="mt-2" />
      </v-col>
    </v-row>

    <v-divider class="mt-5 mb-5" />
    <v-row justifySm="start">
      <v-col>
        <div class="text-h5 mb-4">{{ $t('Scheduling') }}</div>

        <JobConfigurationFormSchedule name="schedule" />
      </v-col>
    </v-row>
  </FormSection>
</template>
